import { getAllinpayCheckStatus } from '@/api/apply-product';
import { AllinpayCheckRequestType } from '@/api/apply-product/types';
import router from '@/router';
import Vue from 'vue';
import { CombinedVueInstance } from 'vue/types/vue';

// 定义弹窗组件的类型
interface AllinpayPopData {
  reservePhone: string;
  smsCode: string;
  submitApplyId: string;
  countDownNum: number | null;
  isCountDown: boolean;
}

interface AllinpayPopMethods {
  getSendButtonTextName: () => string;
  onVisibleChange: () => void;
  beforeDestroy: () => void;
  smsCodeFormatter: (val: string) => string;
  renderSmsContent: () => unknown;
  renderCloseIcon: () => unknown;
  onSendSms: () => void;
  onConfirm: (errors: unknown[]) => Promise<void>;
  closePop: () => void;
  startCountDown: () => void;
  clearCountDown: () => void;
}

interface AllinpayPopComputed {
  tqParam: Record<string, unknown>;
}

interface AllinpayPopProps {
  visible: boolean;
  productId: string;
  tqParams: Record<string, unknown>;
  equityTick: boolean;
  processApplyId: string;
  applyId: string;
  bankCardId: string;
}

// 定义弹窗实例类型
type AllinpayPopInstanceType = CombinedVueInstance<
  Vue,
  AllinpayPopData,
  AllinpayPopMethods,
  AllinpayPopComputed,
  AllinpayPopProps
>;

// 保证弹窗单例，解决下一次在倒计时内打开弹窗维持弹窗倒计时功能
let AllinpayPopInstance: AllinpayPopInstanceType | null = null;

export const getAllinpayPopInstance = async (): Promise<AllinpayPopInstanceType> => {
  const AllinpayPop = await import(/* webpackChunkName: "allipay-check-pop" */'./index');
  const AllinpayPopConstructor = Vue.extend(AllinpayPop.default);
  AllinpayPopInstance = new AllinpayPopConstructor({
    router,
  }).$mount() as AllinpayPopInstanceType;
  // 挂载弹窗组件
  document.body.appendChild(AllinpayPopInstance.$el);
  return AllinpayPopInstance;
};

export const destroyInstance = ():void => {
  if (AllinpayPopInstance) {
    AllinpayPopInstance.$destroy();
    AllinpayPopInstance = null;
  }
};

/** 提现流程中是否要展示通联二次绑卡check */
export const doAllinpayAuth = async (
  params: AllinpayCheckRequestType,
):Promise<boolean> => {
  const checkRes = await getAllinpayCheckStatus({
    ...params,
    needBindCardApply: !((AllinpayPopInstance
      && AllinpayPopInstance.$data.countDownNum != null
      && AllinpayPopInstance.$data.countDownNum >= 0)),
  });
  // 通联绑卡校验通过，直接返回，让用户执行后续流程
  if (!checkRes.result) {
    return Promise.resolve(true);
  }
  // 通联绑卡校验不通过
  // 1. 弹出通联绑卡验证弹窗
  return new Promise(async (resolve) => {
    // 异常加载验证码弹窗组件
    if (!AllinpayPopInstance) {
      await getAllinpayPopInstance();
    }

    if (AllinpayPopInstance) {
      // 首次打开弹窗，传入processApplyId、applyId记录为一次验证流程，保持3次验证逻辑
      const { processApplyId, applyId } = checkRes;
      // 弹窗组件的参数，绑定的银行卡id，是否勾选权益，产品id
      const {
        bankCardId, equityTick, productId, tqParams = {},
      } = params;

      AllinpayPopInstance.$props.visible = true;
      AllinpayPopInstance.$props.productId = productId;

      // 后端返回值再用新值，否则一直用旧值
      if (processApplyId) {
        AllinpayPopInstance.$props.processApplyId = processApplyId;
      }
      if (applyId) {
        AllinpayPopInstance.$props.applyId = applyId;
      }


      AllinpayPopInstance.$props.bankCardId = bankCardId;
      AllinpayPopInstance.$props.equityTick = equityTick;
      AllinpayPopInstance.$props.tqParams = tqParams;

      // 定义关闭事件
      AllinpayPopInstance.$on('close', () => {
      // 监听关闭时间，resolve false来阻断流程
        if (AllinpayPopInstance) {
          AllinpayPopInstance.$props.visible = false;
        }

        resolve(false);
      });

      // 监听确认事件，来执行后续流程
      AllinpayPopInstance.$on('confirm', () => {
        if (AllinpayPopInstance) {
          AllinpayPopInstance.$props.visible = false;
        }
        resolve(true);
      });
    }
  });
};
